import React from "react";
import "./CicdBootstrapPlan.css";

// Presentation only: checks, approval and requests stay in CicdSetup.
function PlanIcon({ shield = false }) {
  return <svg className="cs-plan-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    {shield ? <><path d="M12 3 4 6v5c0 5 8 10 8 10s8-5 8-10V6z"/><path d="m9 12 2 2 4-4"/></>
      : <><path d="M5 3h14v18H5zM9 3v18M12 8h4M12 12h4"/></>}
  </svg>;
}

export default function CicdBootstrapPlan({ result, canBootstrap, t }) {
  return <div className="cs-plan">
    <div className="cs-plan-destination">
      <h4>{t("checks.targetAccount", { owner: result.owner, host: result.baseUrl || "https://github.com" })}</h4>
      <p className="cs-hint">{t("checks.readOnlyCheck")}</p>
    </div>
    {!canBootstrap && !result.setupCheck?.blocked && <div className="cs-msg warn" role="status">{t(result.targets.some(target => target.exists) ? "checks.repoConflict" : result.targets.some(target => target.reserved) ? "checks.repoReserved" : "checks.notApproved")}</div>}
    {result.setupCheck && <section className="cs-plan-checks" aria-label={t("cicd.check.title")}>
      <h4>{t("cicd.check.title")}</h4>
      <p role="status">{t(result.setupCheck.blocked ? "cicd.check.blocked" : "cicd.check.incomplete")}</p>
      <details className="cs-plan-disclosure" open={result.setupCheck.blocked || undefined}>
      <summary>{t("cicd.check.details", {
        passed: result.setupCheck.checks.filter(check => check.status === "pass").length,
        failed: result.setupCheck.checks.filter(check => check.status === "fail").length,
        unknown: result.setupCheck.checks.filter(check => check.status === "unknown").length,
      })}</summary>
      <ul>{result.setupCheck.checks.map((check, index) => <li key={`${check.code}-${index}`}>
        <span>{t(`cicd.check.items.${check.code}`, { ...check.params, defaultValue: t("cicd.check.unknownCheck", { code: check.code }) })}</span>
        <strong>{t(`cicd.check.status.${check.status}`, { defaultValue: t("cicd.check.status.unknown") })}</strong>
      </li>)}</ul>
      </details>
      <p className="cs-hint">{t("cicd.check.limits")}</p>
    </section>}
    <div className="cs-plan-map">
      <section className="cs-plan-targets" aria-label={t("checks.targets")}>
        <h4><PlanIcon/>{t("checks.targets")}</h4>
        <ul className="cs-plan-repositories">{result.targets.map(target => <li key={target.fullName || target.name}>
          <span className="cs-plan-repo-name">{target.fullName || target.name}</span>
          <span className="cs-plan-repo-status">{t(target.exists ? "checks.exists" : target.reserved ? "checks.reserved" : "checks.newRepo")}</span>
          <span className="cs-plan-repo-url">{`${result.baseUrl || "https://github.com"}/${target.fullName || target.name}`}</span>
        </li>)}</ul>
      </section>
      <section className="cs-plan-existing" aria-label={t("presentation.existingTitle")}>
        <h4><PlanIcon shield/>{t("presentation.existingTitle")}</h4>
        <p>{t("checks.existingProtected")}</p>
        <details className="cs-plan-disclosure">
          <summary>{t("checks.repoCount", { count: result.repositories.length })}</summary>
          <div className="cs-plan-disclosure-body">
            <p className="cs-hint">{t("checks.repositoryScope")}</p>
            {result.repositories.length === 0 && <p>{t("checks.noRepositories")}</p>}
            <ul className="cs-repos">{result.repositories.map(repo => <li key={repo.id || repo.fullName}>
              <span className="name">{repo.fullName}</span><span className="meta">{t("checks.unchanged")}</span>
            </li>)}</ul>
          </div>
        </details>
      </section>
    </div>
    <section className="cs-plan-sequence" aria-label={t("checks.planTitle")}>
      <h4>{t("checks.planTitle")}</h4>
      <ol className="cs-plan-steps">{result.plan.map((code, index) => <li key={index}>
        <span className="cs-plan-step-number" aria-hidden="true">{index + 1}</span>
        <span>{t(`checks.plan.${code}`, { defaultValue: t("checks.unknownStep", { code }) })}</span>
      </li>)}</ol>
      <p className="cs-hint cs-plan-partial">{t("checks.partialCreation")}</p>
    </section>
  </div>;
}
